module.exports = __webpack_public_path__ + "assets/facebook.813664f6.svg";